export const approvedItem = [
  { _id: "approved", name: "تایید شده", value: "true" },
  { _id: "not-approved", name: "تایید نشده", value: "false" },
];
